import ArchitectureDesignForm from "../component/ArchitectureDesignForm";

const CommercialArchitectureDesignCreate = () => {
  return <ArchitectureDesignForm isEditMode={false} />;
};

export default CommercialArchitectureDesignCreate;
